import { render } from "./LocalizedTextWrapper.vue?vue&type=template&id=1b42229f"
import script from "./LocalizedTextWrapper.vue?vue&type=script&lang=js"
export * from "./LocalizedTextWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__